import { Product } from '@diamond/shared/types';
import { useQuery } from '@tanstack/react-query';
import shallow from 'zustand/shallow';

import { mapApiProductsToUI } from '../adapters/highlightAdapter';
import { getProductsFromHighlight } from '../queries/products';
import { useAuthStore } from '../stores';
import { useShipToStore } from '../stores';

export const useGetHighlightItems = (
  id: string,
  page: number,
  size = 12,
  options?: { enabled?: boolean }
) => {
  const token = useAuthStore((s) => s.access_token);
  const [warehouse] = useShipToStore((s) => [s.selectedShipToId], shallow);

  return useQuery({
    queryKey: ['HighlightItems', id, page, size, warehouse],
    enabled: !!id && !!warehouse && (options?.enabled ?? true),
    queryFn: async () => {
      const res = await getProductsFromHighlight(token, id, {
        size,
        page,
        warehouse,
      });
      return {
        items: mapApiProductsToUI(res?.data ?? []) as Product[],
        pagination: res?.pagination ?? {},
      } as { items: Product[]; pagination: any };
    },
    staleTime: 1000 * 60 * 4,
    refetchOnWindowFocus: false,
    notifyOnChangeProps: ['data', 'error', 'status'],
  });
};
